module.exports = __webpack_public_path__ + "static/img/technology-bottom.570cd5ea.png";